import React from "react";
import searchIcon from "../../img/search.svg";
import "./CustomInput.css";

const CustomInput = ({ placeholder, onChange, validationError }) => {
  return (
    <div className="input-container">
      <img src={searchIcon} alt="search icon" className="input-icon" />
      <input
        type="text"
        placeholder={placeholder}
        className={`input-field ${validationError ? "input-error" : ""}`}
        onChange={onChange}
      />
    </div>
  );
};

export default CustomInput;
